// GenericSelect.jsx
import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';

const GenericSelect = ({
  label,
  value,
  onChange,
  options,
  disabled = false,
  size = 'small',
  sx = {},
}) => (
  <FormControl size={size} fullWidth disabled={disabled} sx={textfieldStyle}>
    <InputLabel id={`select-${label}`}>{label}</InputLabel>
    <Select
      labelId={`select-${label}`}
      value={value}
      label={label}
      onChange={e => onChange(e.target.value)}
      MenuProps={{
        PaperProps: {
          sx: {
            backgroundColor: '#252525',
            '& .MuiMenuItem-root': {
              color: '#fff',
              '&:hover': { backgroundColor: '#353535' },
            },
          },
        },
      }}
      sx={{
        fontSize: '1.9vh',
        textAlign: 'center',
        mt: '0.2vh',
        height: '4.5vh',
        color: 'rgba(255,255,255,0.7)',
      }}
    >
      {options.map(opt => (
        <MenuItem key={opt.value} value={opt.value} sx={{ fontSize: '1.8vh' }}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default GenericSelect;
const textfieldStyle = {
  width: '15vw',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'rgba(233, 78, 26, .3)'
    },
    '&:hover fieldset': {
      borderColor: 'rgba(233, 78, 26, .7)'
    },
    '&.Mui-focused fieldset': {
      borderColor: 'rgba(233, 78, 26, .9)'
    },
    '& .MuiInputBase-input': {
      color: '#c3c3c3',
      fontSize: '0.8vw'
    },
    '& .MuiSelect-select': {
      textAlign: 'center'
    },
    '& .MuiSelect-icon': {
      color: 'rgba(255,255,255,0.7)',
      fontSize: '1vw'
    }
  },
  // Estilo del label centrado SOLO cuando no está flotando
  '& .MuiInputLabel-root': {
    color: '#c3c3c3',
    fontSize: '0.8vw',
    top: '50%',
    left:'10%',
    transform: 'translateY(-50%)',
    transition: 'all 0.2s ease'
  },
  // Cuando está flotando (shrink), vuelve a su posición normal
  '& .MuiInputLabel-shrink': {
    top: '-30%',
    left:'4%',
    transform: 'translateY(0)',
    fontSize: '0.7vw'
  }
};
